// Como se CUENTA una entrega de correo, en las dos pantallas que la muestran
// (7-sep-2026).
//
// Vive aqui, y no en cada pantalla, porque el mismo aviso fallido se ensena en dos
// sitios -la bandeja y el expediente- y son la misma informacion: si divergen, el
// operador ve dos versiones del mismo hecho y deja de fiarse de las dos. La bandeja
// ya traducia; el expediente escupia la excepcion cruda del SDK de Azure.

/**
 * Lo que el SISTEMA guarda vs. lo que la PERSONA lee.
 *
 * `fallido` se dice «no enviado» a proposito. "Fallido" nombra el resultado tecnico de
 * la operacion; quien mira el expediente necesita saber otra cosa: si esa persona se
 * entero o no. Y no se entero.
 *
 * El indice es `string` y no la union de los tres estados PORQUE el estado llega del
 * servidor: si manana agrega uno, el tipo estrecho obligaria a un `as` en la frontera
 * y el codigo mentiria sobre lo que de verdad puede llegar. El `?? estado` de abajo
 * existe justamente para ese caso, y con la union seria inalcanzable.
 */
const ROTULOS: Record<string, string> = {
  enviado: 'enviado',
  fallido: 'no enviado',
  pendiente: 'pendiente',
};

export const rotuloDeEntrega = (estado?: string | null): string =>
  ROTULOS[estado ?? ''] ?? estado ?? '—';

/** Los estados que hay que destacar en rojo: solo el que significa que nadie leyo nada. */
export const esEntregaFallida = (estado?: string | null): boolean => estado === 'fallido';
